import axios from '@/libs/api.request'
import config from '@/config'

const privateCloudBaseUrl = config.basePrivateCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudUser = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'private_cloud_user/',
    params: params,
    method: 'get'
  })
}

export const getPrivateCloudAllUser = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'all_private_cloud_user_list/',
    params: params,
    method: 'get'
  })
}

export const detailPrivateCloudUser = (params, id) => {
  return axios.request({
    url: `${privateCloudBaseUrl}private_cloud_user/${id}/`,
    params: params,
    method: 'get'
  })
}

export const getPrivateCloudUserProjects = (params) => {
  return axios.request({
    url: `${privateCloudBaseUrl}private_cloud_user/projects/`,
    params: params,
    defaultTenant: true,
    method: 'get'
  })
}

export const checkPrivateCloudSelfActive = (params) => {
  return axios.request({
    url: `${privateCloudBaseUrl}private_cloud_user/self_check_active/`,
    defaultTenant: true,
    params: params,
    method: 'get'
  })
}

export const checkPrivateCloudUserActive = (id, params) => {
  return axios.request({
    url: `${privateCloudBaseUrl}private_cloud_user/${id}/check_active/`,
    params: params,
    method: 'get'
  })
}

export const activePrivateCloudUser = (data) => {
  return axios.request({
    url: `${privateCloudBaseUrl}private_cloud_user/active/`,
    data: data,
    method: 'post'
  })
}

export const updatePrivateCloudUser = (data, id) => {
  return axios.request({
    url: `${privateCloudBaseUrl}private_cloud_user/${id}/`,
    data: data,
    defaultTenant: true,
    method: 'put'
  })
}

export const cancelActivePrivateCloudUser = (id, data) => {
  return axios.request({
    url: `${privateCloudBaseUrl}private_cloud_user/${id}/`,
    data: data,
    method: 'delete'
  })
}

export const assignProjectPrivateCloud = (data, id) => {
  return axios.request({
    url: `${privateCloudBaseUrl}private_cloud_user/${id}/assign_project/`,
    defaultTenant: true,
    data: data,
    method: 'post'
  })
}
